
import React, {FC} from 'react';
import {SwipeableHandlers} from 'react-swipeable';

import {Action, State} from './reducer';
import {ScreenConfig} from './types';

export type StateConfig = {
	state: State
	dispatch: React.Dispatch<Action>

	active?: boolean
	screen?: ScreenConfig
	swipes?: SwipeableHandlers
	sdelay?: number // swipe delay (-1 to disable)
}

const StateContext = React.createContext<StateConfig | undefined>(undefined);

type ProviderProps = {
	config: StateConfig
	children?: React.ReactNode
}

export const StateProvider: FC<ProviderProps> = ({config, children}) => {
	return (
		<StateContext.Provider value={config}>
			{children}
		</StateContext.Provider>
	);
};

export const useCtxConfig = () => {
	const ctx = React.useContext(StateContext);
	if (ctx === undefined) {
		throw new Error('useCtxConfig must be used within a StateProvider');
	}
	return ctx;
};
